<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="70px" :model="searchForm" ref="searchForm">
          <el-form-item label="品类">
            <el-select v-model="searchForm.category" filterable placeholder="全部">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in optionData.category" :label="item.content" :key="item.content" :value="item.content"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售等级">
            <el-select v-model="searchForm.saleLocationId" filterable placeholder="全部">
              <el-option label="全部" value="0"></el-option>
              <el-option v-for="item in optionData.saleLocation" :label="item.content" :key="item.content" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类别">
            <el-select v-model="searchForm.productTypeId" filterable placeholder="全部">
              <el-option label="全部" value="0"></el-option>
              <el-option v-for="item in optionData.productType" :label="item.content" :key="item.content" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="resetForm">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="add(false)">新增</el-button>
      </template>

      <el-table
        :data="tableData"
        highlight-current-row
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        style="width: 100%"
        :height="maxTableHeight + 42"
        ref="table"
        border
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          show-overflow-tooltip
          v-for="item in columnData"
          :min-width="item.width"
          :key="item.prop"
          align="center"
          :width="item.prop == 'ruleDesc' ? '320px' : ''"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" class="red-text-btn" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </table-panel>

    <!-- 新增品类弹窗 -->
    <add-dialog
      :visible.sync="addDialogVisible"
      :optionData="optionData"
      @confirm="onAddConfirm"
    />

    <!-- 编辑弹窗 -->
    <edit-table-dialog
      :visible.sync="editDialogVisible"
      :row="editRow"
      :tableData="addTableData"
      :optionData="optionData"
      :columnData="columnData"
      @success="onDialogSuccess"
    />
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin'
import AddDialog from './components/add-dialog.vue'
import EditTableDialog from './components/edit-table-dialog.vue'

export default {
  name: "lifecycleConfiguration",
  mixins: [pagePathMixin, tableMixin],
  components: { AddDialog, EditTableDialog },
  data() {
    return {
      loading: true,
      searchForm: {
        category: "",
        saleLocationId: "0",
        productTypeId: "0",
      },
      tableData: [],
      optionData: [],
      addDialogVisible: false,
      editDialogVisible: false,
      editRow: null,
      addTableData: [],
    };
  },
  computed: {
    columnData() {
      let data = [
        {
          label: "产品类别",
          prop: "productTypeName",
          width: "140px",
          sortable: "custom",
          span: false,
          fixed: "left",
          align: "right",
        },
        {
          label: "品类",
          prop: "category",
          width: "140px",
          sortable: "custom",
          span: false,
          fixed: "left",
          align: "right",
        },
        {
          label: "销售等级",
          prop: "saleLocationName",
          width: "140px",
          sortable: false,
          span: false,
          fixed: "left",
          align: "left",
        },
        {
          label: "下限",
          prop: "limitLower",
          width: "100px",
          sortable: "custom",
          span: false,
          fixed: "left",
          align: "right",
        },
        {
          label: "上限",
          prop: "limitUpper",
          width: "100px",
          sortable: "custom",
          span: false,
          fixed: "left",
          align: "right",
        },
        {
          label: "说明",
          prop: "ruleDesc",
          width: "80px",
          sortable: "custom",
          span: false,
          fixed: "left",
          align: "right",
        },
      ];
      return data;
    },
  },
  methods: {
    onSearch() {
      this.getOptions();
      this.loading = true;
      this.$q.newProduct
        .assessmentRulesList({ data: this.searchForm })
        .then((res) => {
          this.tableData = res.data;
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    resetForm() {
      this.searchForm = {
        category: "",
        saleLocationId: "0",
        productTypeId: "0",
      };
      this.onSearch();
    },
    edit(row) {
      let data = {
        category: row.category,
        saleLocationId: "0",
        productTypeId: "0",
      };
      this.$q.newProduct
        .assessmentRulesList({ data: data })
        .then((res) => {
          this.editTableData = res.data;
        })
        .finally((_) => {
          this.dialogFormVisibleTwo = true;
          this.eialogType = true;
        });
    },
    add() {
      this.dialogFormVisible = true;
      this.eialogType = false;
    },
    input(scope) {
      console.log(scope);
      let row = scope.row;
      row[scope.column.property] = row[scope.column.property].replace(/[^\d]/g, ""); //文字校验
      if (!row.limitUpper && row.limitLower) {
        row.ruleDesc = `销量≥${row.limitLower || ""}`;
      } else if (!row.limitLower && row.limitUpper) {
        row.ruleDesc = `销量<${row.limitUpper || ""}`;
      } else if (row.limitLower && row.limitUpper) {
        row.ruleDesc = `${row.limitUpper || ""}>销量≥${row.limitLower || ""}`;
      } else {
        row.ruleDesc = "";
      }

      //上一行下限默认填充下一行上限
      if (scope.column.label == "下限" && scope.row.productTypeId == this.editTableData[scope.$index + 1].productTypeId) {
        let data = this.editTableData[scope.$index + 1];
        this.$set(this.editTableData[scope.$index + 1], "limitUpper", row[scope.column.property]);
        if (!data.limitUpper && data.limitLower) {
          this.$set(this.editTableData[scope.$index + 1], "ruleDesc", `销量≥${data.limitLower || ""}`);
        } else if (!data.limitLower && data.limitUpper) {
          this.$set(this.editTableData[scope.$index + 1], "ruleDesc", `销量<${row[scope.column.property]}`);
        } else if (data.limitLower && data.limitUpper) {
          this.$set(this.editTableData[scope.$index + 1], "ruleDesc", `${row[scope.column.property]}>销量≥${data.limitLower || ""}`);
        } else {
          this.$set(this.editTableData[scope.$index + 1], "ruleDesc", "");
        }
      } else if (scope.column.label == "上限" && scope.row.productTypeId == this.editTableData[scope.$index - 1].productTypeId) {
        let data = this.editTableData[scope.$index - 1];
        this.$set(this.editTableData[scope.$index - 1], "limitLower", row[scope.column.property]);
        if (!data.limitUpper && data.limitLower) {
          this.$set(this.editTableData[scope.$index - 1], "ruleDesc", `销量≥${data.limitLower || ""}`);
        } else if (!data.limitLower && data.limitUpper) {
          this.$set(this.editTableData[scope.$index - 1], "ruleDesc", `销量<${row[scope.column.property]}`);
        } else if (data.limitLower && data.limitUpper) {
          this.$set(this.editTableData[scope.$index - 1], "ruleDesc", `${row[scope.column.property]}>销量≥${data.limitLower || ""}`);
        } else {
          this.$set(this.editTableData[scope.$index - 1], "ruleDesc", "");
        }
      }
    },
    async del(row) {
      let status = await this.$confirm("是否确认删除该品类下所有配置内容？", "提示", {
        type: "warning",
      });
      if (status !== "confirm") return;
      let params = {
        params: {
          dataId: row.dataId,
        },
      };
      this.$q.newProduct.delAssessmentRule(params).then((res) => {
        if (res.code == 200) {
          this.$message.success("删除成功");
          this.onSearch();
        }
      });
    },
    getOptions() {
      this.$q.newProduct.options({}).then((res) => {
        this.optionData = res.data;
      });
    },
    add() {
      this.addDialogVisible = true;
    },
    edit(row) {
      this.editRow = row;
      this.editDialogVisible = true;
    },
    onAddConfirm(tableData) {
      this.addTableData = tableData;
      this.editRow = null;
      this.editDialogVisible = true;
    },
    onDialogSuccess() {
      this.onSearch();
    },
  },
  mounted() {
    this.onSearch();
  },
  filters: {
    cellvalFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "/";
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-select, >>> .el-input
    width 200px !important

>>> .requestParam .el-input
  width 120px
</style>
